import React from 'react';
import { Clock, MapPin, Ticket, VideoCamera } from '@phosphor-icons/react';
import { format, isSameDay } from 'date-fns';
import { formatTimestamp } from '../../routes/event-list/util';

function EventCard({
  width,
  height = '310px',
  eventName,
  url,
  eventDate,
  startPrice,
  eventCity,
  eventType,
  onClick,
  resale,
  eventSlug,
}) {

  const { monthAbbreviated, startDay, startTime } = formatTimestamp(eventDate);

  return (
    <div
      className="relative rounded-xl mb-5 bg-white shadow-md w-auto overflow-hidden shrink-0 text-left text-sm text-black font-general-sans border border-grey-10 cursor-pointer "
      style={{ width, height }}
      onClick={onClick}
    >
      <div className="absolute top-[0px] left-[0px] filter blur-[18px] w-full h-240px" />
      <div className="w-full h-[190px] overflow-hidden flex flex-row items-start justify-start">
        <img
          className="flex-1 relative max-w-full overflow-hidden h-[240px] object-fill"
          alt={eventName}
          src={url}
        />
      </div>
      <div className="flex flex-col gap-3 p-5 pt-[46px] w-full text-xl">
        <div className="tracking-[-0.5px] font-semibold  ">
          {eventName.length > 30
            ? eventName.substring(0, 29) + '...' // turncate length.
            : eventName}
        </div>
        <div className="w-full flex flex-col items-start justify-start text-base text-secondary-grey">
          <div className="self-stretch  flex flex-col gap-2 items-start justify-start tracking-[-0.5px] truncate">
            <div className="flex gap-2">
              <Clock size={24}
                color={'#878787'} />
              {startTime ?? 'startTime'}
            </div>
            {eventType === 'online' ? (
              <div className="flex gap-2">
                <VideoCamera size={24} color={'#878787'} />
                Online Event
              </div>
            ) : (
              <div className="flex gap-2">
                <MapPin size={24} color={'#878787'} />
                {eventCity}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="absolute top-[160px] left-5 flex w-[51px] h-[60px] flex-col items-center justify-between gap-[6px] shrink-0 rounded-lg bg-white border border-[#ff24591a] text-primary">
        <div className="relative text-primary text-center text-xs not-italic font-medium leading-[104%] uppercase flex justify-center items-center px-3 py-[6px] bg-light rounded-t-lg">
          {monthAbbreviated && monthAbbreviated}
        </div>
        <div className="relative text-xl tracking-[-1px] leading-[102.7%] font-semibold pb-[10px]">
          {startDay && startDay}
        </div>
      </div>
      {startPrice && (
        <div className="absolute top-4 left-4 bg-[#E5FFF6] text-[#009D64] px-[6px] py-1 rounded-[4px] flex gap-1 items-center">
          <Ticket size="18"
            color="#009D64" />
          <span className="font-medium">₹{startPrice} onwards</span>
        </div>
      )}
    </div>
  );
}

export default EventCard;
